module.exports = __webpack_public_path__ + "img/svg/divider-short.35a0c168ba35453211d23d0a0d705636.svg";